
import { partsOfSpeechQuestions } from './questions/parts-of-speech';
import { declensionQuestions } from './questions/declension';
import { subjectPredicateQuestions } from './questions/subject-predicate';
import { verbFormsQuestions } from './questions/verb-forms';
import { exceptionsQuestions } from './questions/exceptions';
import { objectsQuestions } from './questions/objects';

export const questions = [
  ...partsOfSpeechQuestions,
  ...declensionQuestions,
  ...subjectPredicateQuestions,
  ...verbFormsQuestions,
  ...exceptionsQuestions,
  ...objectsQuestions
];
